import { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppProviders } from "./providers/AppProviders";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { InventoryPage } from "./pages/InventoryPage";
import { OrdersHubPage } from "./pages/OrdersHubPage";
import { LocationsPage } from "./pages/LocationsPage";
import { SuppliersPage } from "./pages/SuppliersPage";
import { NewOrderPage } from "./pages/NewOrderPage";
import { AdminPage } from "./pages/AdminPage";
import { CallbackPage } from "./pages/CallbackPage";
import { InvitePage } from "./pages/InvitePage";

const OrderWorkspacePage = lazy(() =>
  import("./pages/OrderWorkspacePage").then((m) => ({ default: m.OrderWorkspacePage })),
);

export default function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Routes>
          <Route path="callback" element={<CallbackPage />} />
          <Route path="invite/:token" element={<InvitePage />} />
          <Route element={<AppShell />}>
            <Route index element={<DashboardPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="catalog" element={<Navigate to="/inventory" replace />} />
            <Route path="orders" element={<OrdersHubPage />} />
            <Route path="orders/new" element={<NewOrderPage />} />
            <Route
              path="orders/:orderId"
              element={
                <Suspense fallback={<p className="muted">Loading workspace…</p>}>
                  <OrderWorkspacePage />
                </Suspense>
              }
            />
            <Route path="locations" element={<LocationsPage />} />
            <Route path="suppliers" element={<SuppliersPage />} />
            <Route path="import" element={<Navigate to="/orders/new" replace />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProviders>
  );
}
